import { setNsoError, clearNsoError, setSimError, clearSimError } from "../redux/errorStep/errorStepSlice";
import { store } from "../store";
import { DataCoreFlowstep, SimEngineFlowStep } from "types/Flowstep/Flowstep.interface";
import { LambdaMapping, lambdamapping } from "./commonFunctions";
import { getSfExecutionSteps } from "services/getStepFunctionData";
import { nsoFlowFetchDataSuccess } from "../redux/nsoFlow/nsoFlowSlice";
import { setFlowId } from "../redux/configPanel/configPanelSlice";
// import { simFlowFetchDataSuccess } from "../redux/simFlow/simFlowSlice";

export enum StepStatus {
  COMPLETE = "COMPLETE",
  ERROR = "ERROR",
}
const updateFlowSteps = (
  steps: (DataCoreFlowstep | SimEngineFlowStep)[],
  errorStep: LambdaMapping,
  status: StepStatus,
) => {
  if (status === StepStatus.COMPLETE) {
    steps.forEach((step) => {
      step.color = "#8af2a4";
      step.enabled = true;
    });
  } else if (status === StepStatus.ERROR) {
    steps.forEach((step) => {
      if (step.stepId <= errorStep.step) {
        step.color = "#8af2a4";
        step.enabled = true;
      } else if (step.stepId === errorStep.step) {
        step.color = "#fc0808";
        step.enabled = true;
      } else {
        step.color = "#fc0808";
        step.enabled = false;
      }
    });
  }
  return steps;
};

export const newTranspile = async (
  stepStatus: StepStatus,
  errorLambda: string,
  errorMsg: string,
  error: string,
  flowSteps: (DataCoreFlowstep | SimEngineFlowStep)[],
  type: "nso" | "sim", // 'nso' or 'sim'
) => {
  const errorStep = lambdamapping.find((lambda) => lambda.errorLambda === errorLambda) as LambdaMapping;
  if (!errorStep) {
    console.error("Error step not found for lambda:", errorLambda);
    return updateFlowSteps(flowSteps, errorStep, stepStatus);
  }
  const updatedErrorStep = { ...errorStep, errorMsg, error };
  if (stepStatus === StepStatus.ERROR) {
    if (type === "nso") {
      store.dispatch(setNsoError(updatedErrorStep));
    } else {
      store.dispatch(setSimError(updatedErrorStep));
    }
  } else {
    if (type === "nso") {
      store.dispatch(clearNsoError());
    } else {
      store.dispatch(clearSimError());
    }
  }

  return updateFlowSteps(flowSteps, updatedErrorStep, stepStatus);
};

export const handleStepFunctionData = async ({
  flowDetailId,
  flowStatus,
  flowSteps,
  type, // 'nso' or 'sim'
}: {
  flowDetailId: string;
  flowStatus: StepStatus;
  flowSteps: (DataCoreFlowstep | SimEngineFlowStep)[];
  type: "nso" | "sim";
}) => {
  const data = await getSfExecutionSteps({ flowDetailId });
  if (typeof data === "boolean") {
    if (!data) {
      return false;
    }
  } else if (data.statusCode === 200 && data.payload[0]?.errors?.flowStatus === "NoDataFound") {
    console.log("NoDataFound");
  } else {
    store.dispatch(setFlowId({ flowId: Number(flowDetailId) }));
    store.dispatch(nsoFlowFetchDataSuccess({ stepID: 1, data: data.payload[0]?.nsodata }));
    store.dispatch(nsoFlowFetchDataSuccess({ stepID: 2, data: data.payload[0]?.vehiclehubdata }));
    return newTranspile(
      flowStatus,
      data.payload[0]?.errors?.errorLambda || "",
      data.payload[0]?.errors?.errorDescription?.msg || "",
      data.payload[0]?.errors?.errorDescription?.error || "",
      flowSteps,
      type,
    );
  }
};
